import React, { useEffect, useState } from 'react';
import './style.scss';
import pg from '../../assets/loaders/powered-by-pascal.png';
import { partnerSkinNames } from '../../core/constants/partnerSkinEnums';

function SkinLoader({ partnerSkin }) {
  const [videoSrc, setVideoSrc] = useState(null);

  useEffect(() => {
    if (partnerSkin) {
      // Dynamically import the video path based on partnerSkin
      import(`../../assets/loaders/${partnerSkinNames[partnerSkin]}-loader.mp4`).then((module) => {
        setVideoSrc(module.default); // Set the path to the state
      });
    } else {
      setVideoSrc(null);
    }
  }, [partnerSkin]);

  return (
    <div className='global-loader-wrapper vbet-ftn-loader' id='loader'>
      <video src={videoSrc} width='480' autoPlay playsInline muted loop id='loaderVideo' />
      <img className='powered-by-image' src={pg} alt='Powered By Pascal Gaming' />
    </div>
  );
}

export default SkinLoader;
